/* eslint-disable import/prefer-default-export */
/* istanbul ignore file */
import { injectLocal, provideLocal } from '@vueuse/core';
import {
  useType as useTypeMCL,
  useCreateTypeStore,
} from '@common-vue/media-card-large/src/modules/type';
import { usePageData } from '@composables/usePageData';
import { useProduct } from '@modules/product';
/**
 * TODO: Traits initialization should be moved to the Product level
 * @description
 * This composable is responsible for providing the type data for the Product.
 */
const TYPE_TRAITS_REPOSITORY = 'type-traits';

/**
 * @returns {ReturnType<typeof useTypeMCL>}
 */
export const useType = () => {
  const { productId: id } = useProduct();
  const resultRepository = `${TYPE_TRAITS_REPOSITORY}-${id}`;
  const providedContext = injectLocal(resultRepository);

  if (providedContext) {
    return providedContext;
  }

  useCreateTypeStore({ id, data: usePageData().traits.type[id] });

  const context = useTypeMCL(id);
  provideLocal(resultRepository, context);

  return context;
};
